import { render, staticRenderFns } from "./MedicalNoteCategoryCopyTemplate.vue?vue&type=template&id=46c05d50&scoped=true"
import script from "./MedicalNoteCategoryCopyTemplate.vue?vue&type=script&lang=js"
export * from "./MedicalNoteCategoryCopyTemplate.vue?vue&type=script&lang=js"
import style0 from "./MedicalNoteCategoryCopyTemplate.vue?vue&type=style&index=0&id=46c05d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c05d50",
  null
  
)

export default component.exports